export const AVAILABLE_MODELS = [
	{ key: 'gpt-5.1', name: 'GPT 5.1', vendor: 'OpenAI' },
	{ key: 'gpt-5-mini', name: 'GPT 5 mini', vendor: 'OpenAI' },
	{ key: 'gpt-5-nano', name: 'GPT 5 nano', vendor: 'OpenAI' },
	{ key: 'o4-mini', name: 'o4 mini', vendor: 'OpenAI' },
	{ key: 'gpt-4.1', name: 'GPT 4.1', vendor: 'OpenAI' },
	{ key: 'gpt-oss-120b', name: 'GPT OSS', vendor: 'OpenAI' },

	{ key: 'claude-opus-4-6', name: 'Claude Opus 4.6', vendor: 'Anthropic' },
	{ key: 'claude-sonnet-4-6', name: 'Claude Sonnet 4.6', vendor: 'Anthropic' },
	{ key: 'claude-haiku-4-5', name: 'Claude Haiku 4.5', vendor: 'Anthropic' },

	{
		key: 'eu.anthropic.claude-opus-4-6-v1',
		name: 'Claude Opus 4.6',
		vendor: 'Anthropic via Amazon Bedrock (EU)'
	},
	{
		key: 'eu.anthropic.claude-sonnet-4-6',
		name: 'Claude Sonnet 4.6',
		vendor: 'Anthropic via Amazon Bedrock (EU)'
	},
	{
		key: 'eu.anthropic.claude-haiku-4-5-20251001-v1:0',
		name: 'Claude Haiku 4.5',
		vendor: 'Anthropic via Amazon Bedrock (EU)'
	},

	{ key: 'llama-3.3-70b-instruct', name: 'Llama 3.3 (70b)', vendor: 'Meta' },

	{ key: 'mistral-large-latest', name: 'Mistral Large', vendor: 'Mistral' },
	{ key: 'mistral-medium-latest', name: 'Mistral Medium', vendor: 'Mistral' },
	{ key: 'mistral-small-latest', name: 'Mistral Small', vendor: 'Mistral' },
	{ key: 'magistral-medium-latest', name: 'Magistral Medium', vendor: 'Mistral' },
	{ key: 'magistral-small-latest', name: 'Magistral Small', vendor: 'Mistral' },

	{ key: 'gemma-3-27b-it', name: 'Gemma 3 (27b)', vendor: 'Google' },

	{ key: 'deepseek-r1-distill-llama-70b', name: 'DeepSeek r1 (70b)', vendor: 'DeepSeek' },

	{ key: 'qwen3-235b-a22b-instruct-2507', name: 'Qwen 3 (22b)', vendor: 'Alibaba' },

	{ key: 'holo2-30b-a3b', name: 'Holo 2 (30b)', vendor: 'H Company' }
];

export const DEFAULT_FALLBACK_MODEL = 'eu.anthropic.claude-sonnet-4-6';
